module.exports = function debounce(fn, delay) {
	var timer, lastTimestamp, ctx, args;

	function done() {
		var remainingWait = delay - (Date.now() - lastTimestamp);

		if(remainingWait > 0) {
			timer = setTimeout(done, remainingWait);
		} else {
			timer = null;
			fn.apply(ctx, args);
			context = args = null; // free references in case these should be garbage collected
		}
	}

	return function () {
		ctx = this;

		lastTimestamp = Date.now();

		//equivalent to function(...innerArgs)
		for (var _len = arguments.length, innerArgs = Array(_len), _key = 0; _key < _len; _key++) {
			innerArgs[_key] = arguments[_key];
		}

		args = innerArgs;

		if(!timer) timer = setTimeout(done, delay);
	};
};
